function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.96094 2.64062C6.05469 2.33594 6.33594 2.125 6.66406 2.125H9.33594C9.66406 2.125 9.94531 2.33594 10.0391 2.64062L10.25 3.25H12.5C12.9219 3.25 13.25 3.57812 13.25 4C13.25 4.42188 12.9219 4.75 12.5 4.75H3.5C3.07812 4.75 2.75 4.42188 2.75 4C2.75 3.57812 3.07812 3.25 3.5 3.25H5.75L5.96094 2.64062ZM12.5 5.875L12.0078 13.4453C11.9609 14.0312 11.4688 14.5 10.8828 14.5H5.11719C4.53125 14.5 4.03906 14.0312 3.99219 13.4453L3.5 5.875H12.5Z",
  fill: "#E03A3E"
});

function SvgRedBin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedBin);
export default __webpack_public_path__ + "static/media/red-bin.d7134d9b.svg";
export { ForwardRef as ReactComponent };